@if(!hidden()){
<div class="flex flex-col pt-16 pb-24 gap-16 items-center justify-center">
  <h2 class="text-3xl font-bold text-white">Friends of Bongo's Bingo</h2>
  <div class="flex xl:flex-row flex-col items-center gap-6 xl:gap-14">

    @for(partner of partners(); track $index) {
    <a [href]="partner.website_url" target="_blank"><img [src]="partner.image_url" [alt]="partner.name"
        class="h-44" /></a>
    }
  </div>
</div>
}